import React from "react";
import t from "../../../../../helpers/t";
import { moment } from "../../../../../../../vendor";
import { rbac } from "../../../index";

const MobileView = (props) => {
  const { usergroup, index, deleteUserGroupPending, onDeleteUserGroup, currentUrl } = props;
  return (
    <>
      <div
        className={"inb-c-item inb-c-item--order row show-for-medium-only"}
        key={index}
        style={{ minHeight: "132px" }}
      >
        {/* {Biscuit.get('user.is_superuser')  === 'true' &&  <aside className="inb-c-item__actions">
                          <DropdownButton id="dropdown-basic-button" title="..." drop="right" menuAlign="right"
                                          bsPrefix="button round inb-toggle-contingent-dd hover">
                            <ul className="inb-dropdown__list">
                              <li data-inb-action-link='changelog' id="kln_changelog">
                                <Dropdown.Item href='#' onClick={() => openChangeLog(usergroup.changeLogs)}>
                                  <i className="fi fi-wrench"> </i>
                                  {t('changelog', null, 'capital')}
                                </Dropdown.Item>
                              </li>
                            </ul>
                          </DropdownButton>


                        </aside>}*/}
        <div
          className="large-2 medium-8 small-8 column show-label"
          title={t("id", null, "capital")}
        >
          <span>{usergroup.id}</span>
        </div>
        <div
          className="large-2 medium-8 small-8 column show-label"
          title={t("name", null, "capital")}
        >
          <span>{usergroup.name}</span>
        </div>
        <div
          className="large-2 medium-8 small-8 column show-label"
          title={t("domain", null, "capital")}
        >
          <span>{usergroup.domain}</span>
        </div>

        <div
          className="medium-offset-0 medium-1 small-3 column item-button-group"
          id="edit-delete-button-group"
          style={{ top: "5%", margin: 0, right: 0, float: "left", display: "block" }}
        >
          <div className="button-container">
            {rbac.hasPermission("delete") && (
              <>
                {deleteUserGroupPending !== index ? (
                  <>
                    <a href="#" className="inb-reservation__pdf2" title={t("delete")}>
                      <button
                        type="button"
                        className="inb-round-btn hollow round float-left"
                        onClick={() => onDeleteUserGroup(usergroup, index)}
                      >
                        <div className="inb-fi-remove"></div>
                      </button>
                    </a>
                  </>
                ) : (
                  <>
                    <span>
                      <img
                        alt="RollingLoader"
                        className="rollingLoader colorize-black"
                        src={"assets/img/rolling_loader.svg"}
                      />{" "}
                    </span>
                  </>
                )}
              </>
            )}
          </div>
          <div className="button-container" id="list">
            {rbac.hasPermission("editUser") && (
              <a
                href={
                  "/usersExtension/userGroups/" +
                  usergroup.id +
                  "?path=" +
                  "/usersExtension/userGroups" +
                  currentUrl.search.replace("?", "&")
                }
                title={t("edit")}
                data-inb-action-link="edit"
              >
                <button type="button" className="inb-round-btn hollow round float-left">
                  <div className="inb-fi-edit"></div>
                </button>
              </a>
            )}
          </div>
        </div>

        <div
          className="medium-offset-0 medium-1 small-1 column item-button-group"
          id="list-user-button"
          style={{ top: "5%", margin: 0, right: "8%", float: "left", display: "block" }}
        >
          <div className="button-container">
            <a
              href={
                "/usersExtension/userGroups/" +
                usergroup.id +
                "/listUsers" +
                currentUrl.search.replace("?", "&")
              }
              title={t("list")}
              data-inb-action-link="list"
            >
              <button type="button" className="inb-round-btn hollow round float-left">
                <div className="inb-fi-list"></div>
              </button>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileView;
